import { Fragment } from "react/jsx-runtime";
import { JobTaskWizard } from "../../../Create/Steps/JobTasks";
import { useState } from "react";
import { CardOverflow } from "@mui/joy";
import { CardActions } from "@mui/material";
import { Button } from "primereact/button";
import { siteJobTasksAdd } from "../../../../../service/JobTaskService";

export default function AddTasks(modalProps: any) {

  const [formData, setFormData] = useState<any>({});
  function handleKeyValueChange(name: string, value: unknown) {
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  async function TaskAdd() {
      console.log("formData.job_task == ", formData.job_task);
        modalProps.setGlobalLoading(true);
      siteJobTasksAdd(formData.job_task).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Tasks Added Successfully",
          life: 3000,
        });
        modalProps.setReload?.(!modalProps.reload);
        modalProps.setVisible?.(false);
        modalProps.setGlobalLoading(false);
      }).catch((e: any) => {
        modalProps.toast.current.show({
          severity: "error",
          summary: "Error Adding Tasks",
          life: 3000,
        });
        modalProps.setGlobalLoading(false);
      });
    }

  return (
    <Fragment>
      <JobTaskWizard handleChange={handleKeyValueChange} formData={formData} />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => TaskAdd()}
          />
        </CardActions>
      </CardOverflow>
    </Fragment>
  );
}

